<template>
  <VWidget
    :title="$t('Discount details')"
    class="mb-4"
  >
    <div slot="widget-header-action">
      <v-spacer/>
      <v-switch
        :error-messages="item.displayErrors('active')"
        v-model="item.active"
        :label="$t('Active')"
        class="mt-4"
      />
    </div>
    <div slot="widget-content">
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
          md6
        >
          <v-text-field
            v-model="item.name"
            :error-messages="item.displayErrors('name')"
            :label="$t('Discount Name')"
            outline
          />

        </v-flex>
        <v-flex
          xs12
          md6
        >
          <v-text-field
            v-if="['fixed', 'distributed'].includes(item.rate_type)"
            v-model="moneyValue"
            :error-messages="item.displayErrors('value')"
            :prefix="prefix"
            :label="$t('Rate')"
            outline
            @input="handleMoneyValueChange"
          />
          <v-text-field
            v-else
            v-model="item.value"
            :error-messages="item.displayErrors('value')"
            :label="$t('Rate')"
            prefix="%"
            outline
          />
        </v-flex>
        <v-flex
          xs12
        >
          <v-text-field
            v-model="item.description"
            :error-messages="item.displayErrors('description')"
            :label="$t('Discount Description')"
            outline
            persistent-hint
          />
        </v-flex>
      </v-layout>
    </div>
  </VWidget>
</template>

<script>
import Money from 'js-money'
import currencies from '@/../node_modules/js-money/lib/currency'
import { mapGetters } from 'vuex'

export default {
  name: 'DiscountSingleDetails',

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      moneyValue: null
    }
  },

  computed: {
    ...mapGetters(['currency', 'currencySymbol']),

    prefix () {
      return this.item.rate_type === 'distributed' ? '~' : this.currencySymbol
    }
  },

  watch: {
    'item.rate_type': {
      handler: function (newRateType, oldRateType) {
        if (newRateType !== oldRateType) {
          this.item.value = null
          this.moneyValue = null
        }
      },
      deep: true
    }
  },

  mounted () {
    if (['fixed', 'distributed'].includes(this.item.rate_type)) {
      this.moneyValue = this.item.value
        ? Money.fromInteger({ amount: parseInt(this.item.value), currency: this.currency }) : null
    }
  },

  methods: {
    handleMoneyValueChange (value) {
      if (value !== '' && value !== null) {
        let currencyInfo = currencies[this.currency]
        // converting float value to integer money format
        value = parseInt(parseFloat(value).toFixed(currencyInfo.decimal_digits).toString().replace(/[,.]/g, ''))
      }
      this.item.value = value
    }
  }
}
</script>
